export default __webpack_public_path__ + "static/media/Trello-Logo.wine.dce43317.png";